import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import getApiData from "../../../../hooks/apiRequests/getRequest";
import ConfigTable from "./table/configTable";
import FeatureBanner from "./features/featuresBanner";

const TennatSettings =  () => {
    const [configList, setConfigList] = useState([]);
    const navigate = useNavigate();
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getApiData(`/Configs/List`);
                setConfigList(response.data);
            } catch (error) {
                console.error('Error fetching product data:', error);
            }
        };
        fetchData();
    }, [navigate]);
    
    return(
        <>
            <Typography variant="h5" component="div" sx={{ p: 2, color: 'black'}}>
                Tenant Settings
            </Typography>
            <FeatureBanner />
            <Typography variant="h5" component="div" sx={{ p: 2, color: 'black'}}>
                Configs
            </Typography>
            <ConfigTable configList={configList}/>
        </>
    );
};
export default TennatSettings;